const TOKEN_KEY = 'ai_token';
const UUID_KEY = 'ai_uuid';

export const saveToken = (token,uuid) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(UUID_KEY, uuid);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getUuid = () => localStorage.getItem(UUID_KEY);
export const isAuthenticated = () => !!getToken();

export const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(UUID_KEY);
};

export default { saveToken, getToken, getUuid, isAuthenticated, logout };